module.exports = __webpack_public_path__ + "img/aaxx.f481fbbc.png";